import React from "react";

import MainLayout from '../layouts/MainLayout'
import HistoryList from '../components/HistoryList'

const History = () => {
  return (
    <MainLayout>
      <h1 className="text-4xl font-semibold text-gray-800 dark:text-white">Dossiers archivés</h1>
      <h2 className=" text-gray-400">Historique des interventions</h2>
      <HistoryList/>
    </MainLayout>
  );
}

export default History
